module.exports = __webpack_public_path__ + "img/gd.5df5e43f.png";